// customization:
// - passato campo event_period_text a When
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import {
  InfoBox,
  Booking,
  DownloadButton,
  ViewBlocks,
  RichText,
  RelatedItems,
  Ticket,
} from '@redturtle/iovisit-theme/components/Views';

import { When } from '@redturtle/iovisit-theme/components';

const messages = defineMessages({
  eventDate: {
    id: 'event_date',
    defaultMessage: 'Data',
  },
  downloadProgram: {
    id: 'event_download_program',
    defaultMessage: 'Scarica programma',
  },
  downloadPoster: {
    id: 'event_download_poster',
    defaultMessage: 'Scarica la locandina',
  },
  related_items: {
    id: 'event_related_items',
    defaultMessage: 'Continua ad esplorare',
  },
  extra_info: {
    id: 'event_extra_info',
    defaultMessage: 'Per saperne di più',
  },
  timetable: { id: 'event_timetable', defaultMessage: 'Orari' },
  prices: { id: 'event_prices', defaultMessage: 'Prezzi' },
});

const EventView = ({ content, location }) => {
  const intl = useIntl();

  const timetable = RichText({
    content: content.timetable,
    title: intl.formatMessage(messages.timetable),
    titleTag: 'h3',
  });

  const prices = RichText({
    content: content.prices,
    title: intl.formatMessage(messages.prices),
    titleTag: 'h3',
  });

  return (
    <div id="page-event" className="ui container">
      <InfoBox>
        <h3>{intl.formatMessage(messages.eventDate)}</h3>
        <When
          start={content.start}
          end={content.end}
          whole_day={content.whole_day}
          open_end={content.open_end}
          show_times={true}
          recurrence={content.recurrence}
          event_period_text={content.event_period_text}
        />
        {timetable}
        {prices}
        <Ticket content={content} />
        <Booking content={content} />
        {content.program && (
          <DownloadButton
            file={content.program}
            title={
              content.program_title ??
              intl.formatMessage(messages.downloadProgram)
            }
            className="ui button primary event"
          />
        )}
        {content.poster && (
          <DownloadButton
            file={content.poster}
            title={
              content.poster_title ??
              intl.formatMessage(messages.downloadPoster)
            }
            className="ui button primary event"
          />
        )}
      </InfoBox>

      <ViewBlocks content={content} location={location} />

      {content.extra_info?.length > 0 && (
        <RelatedItems
          title={intl.formatMessage(messages.extra_info)}
          items={content.extra_info}
          background={true}
        />
      )}

      {content.relatedItems?.length > 0 && (
        <RelatedItems
          title={intl.formatMessage(messages.related_items)}
          items={content.relatedItems}
          background={(content.extra_info || []).length === 0}
          bg_color="tertiary"
        />
      )}
    </div>
  );
};

export default EventView;
